import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import baseFormMuiTheme from './baseFormMuiTheme';

const theme = createTheme(baseFormMuiTheme);

const formResponseMuiTheme = createTheme(
  deepmerge(theme, {
    typography: {
      caption: {
        color: theme.palette.normalText.dark,
      },
    },
    components: {},
  }),
);

export default formResponseMuiTheme;
